import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_STA015_Request,
  IAPI_STA015_Response,
  IAPI_STA016_Request,
  IAPI_STA016_Response,
  IAPI_STA024_Request,
  IAPI_STA024_Response,
  IAPI_STA028_Request,
  IAPI_STA028_Response,
  IAPI_BUS008_Request,
  IAPI_BUS008_Response,
} from "../../../type/apiType";

// 加入登録手続き修正参照
// API仕様書_法人職員
const httpAPI_STA024 = async (
  param: IAPI_STA024_Request
): Promise<IAPI_STA024_Response> => {
  let res = await http.post(ApiUrl.API_STA024, {
    ...param,
  });

  return res.data;
};

// 加入登録手続き参照
// API仕様書_法人職員
const httpAPI_STA016 = async (
  param: IAPI_STA016_Request
): Promise<IAPI_STA016_Response> => {
  let res = await http.post(ApiUrl.API_STA016, {
    ...param,
  });

  return res.data;
};

// 加入登録手続き更新
// API仕様書_法人職員
const httpAPI_STA015 = async (
  param: IAPI_STA015_Request
): Promise<IAPI_STA015_Response> => {
  let res = await http.post(ApiUrl.API_STA015, {
    ...param,
  });

  return res.data;
};

// 加入登録手続き引継ぎ参照
// API仕様書_法人職員
const httpAPI_STA028 = async (
  param: IAPI_STA028_Request
): Promise<IAPI_STA028_Response> => {
  let res = await http.post(ApiUrl.API_STA028, {
    ...param,
  });

  return res.data;
};

// 加入登録時の整合性チェック
// 業務チェック
const httpAPI_BUS008 = async (
  param: IAPI_BUS008_Request
): Promise<IAPI_BUS008_Response> => {
  let res = await http.post(ApiUrl.API_BUS008, {
    ...param,
  });

  return res.data;
};

export {
  httpAPI_STA024,
  httpAPI_STA016,
  httpAPI_STA015,
  httpAPI_STA028,
  httpAPI_BUS008,
};
